import SectionItemList from './../index-edit/SectionItemList'

export default {
	name: 'NavEditor',
	props: {
		value: {
			type: Object
		}
	},
	components: {
		SectionItemList,
	},
	template: `
		<div class="nav-editor">
			<SectionItemList v-model="value" />
		</div>
	`,
}
